import "./LandingPage.scss";

import React from "react";

import {
  Grid2,
} from "@mui/material";

import AlertComponent from "../../shared/components/alert-component/AlertComponent";
import AsideContent from "../../shared/components/aside-content/AsideContent";
import ContentBlock from "../../shared/components/content-block/ContentBlock";
import HeroPageComponent from "../../shared/components/hero-page-component/HeroPageComponent";
import {
  FeatureToggle,
  LandingPageContent,
  PhSiteSettings
} from "../../shared/models/app-data-model";
import { getContentHubDamAsset } from "../../shared/utils/get-contenthub-dam-asset";

export type LandingPageProps = {
  content: LandingPageContent;
  featureToggles: FeatureToggle[];
  phSiteSettings: PhSiteSettings;
};

const LandingPage: React.FC<LandingPageProps> = (props: LandingPageProps) => {
  const hero = props.content.page_header;

  const includeAsideNav = props.content.include_aside_on_this_page;
  const asideContent = includeAsideNav && <AsideContent asideContent={props.content.aside_content} />;
  const pageAlert = props.content.page_alert;
  const pageAlertData = pageAlert && pageAlert.map((alert, index) => 
  alert.alert_reference.length > 0 ? <AlertComponent message={alert.alert_reference[0]?.alert_message} severityLevel={alert.alert_reference[0]?.alert_type} button={alert.alert_reference[0]?.button} key={index}></AlertComponent> : null);

  const contenthubDamAsset = hero && getContentHubDamAsset(hero.contenthub_asset);
  const contentHeader = props.content.page_content && props.content.page_content.content_header;

  const contents = props.content.page_content && props.content.page_content.content_block.length > 0 
    ? props.content.page_content.content_block.map((item, index) => <ContentBlock featureToggles={props.featureToggles} phSiteSettings={props.phSiteSettings} contentBlock={item} key={index} />)
    : null;
  
  return(

    <>
      <Grid2 container rowSpacing={2} columnSpacing={3} className='landingpage' maxWidth="xl">
        <Grid2 size={{ xs: 12}} className="hero_wrapper">
          {hero && <HeroPageComponent hero={hero} damAsset={contenthubDamAsset}></HeroPageComponent>}
        </Grid2>
        <Grid2 container size={{ xs: 12}}>
          {pageAlertData}
        </Grid2>
        {includeAsideNav && asideContent && <Grid2 container size={{ xs: 12, md: 4, lg:3 }} component='aside' className="page-aside">
          {asideContent}
        </Grid2>}
        <Grid2 container className="pageContent" component='main' size="grow">
          {contentHeader && <h2 className="page-content-header">{contentHeader}</h2>}
          <div>{contents}</div>
        </Grid2>
      </Grid2>
    </>
  ); 
};

export default LandingPage;
